module.exports = __webpack_public_path__ + "static/img/notice.e0342fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme1/notice.png
// module id = /AfI
// module chunks = 78